import { LocalizationProvider } from '@mui/lab'
import { muiTheme } from './theme'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import brLocale from 'date-fns/locale/pt-BR'
import { ThemeProvider } from '@mui/material/styles'
import { QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { queryClient } from './lib'
import { API_URL } from './config'
import { AuthProvider } from './lib/auth'
import { ToastContainer } from 'react-toastify'
import { BrowserRouter } from 'react-router-dom'

import 'react-toastify/dist/ReactToastify.css'
import { AppRoutes } from './routes/app.route'

export const App = () => {
  console.log(API_URL, process.env.NODE_ENV)
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={brLocale}>
      <QueryClientProvider client={queryClient}>
        {process.env.NODE_ENV === 'development' && <ReactQueryDevtools />}
        <ToastContainer position="top-left" />
        <ThemeProvider theme={muiTheme}>
          <AuthProvider>
            <BrowserRouter>
              {/* <Routes /> */}
              <AppRoutes />
            </BrowserRouter>
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </LocalizationProvider>
  )
}
